'use client';

import type React from 'react';
import { cn } from '@/lib/ui-kit/utils';

/**
 * Segmented control (Stop-Market / Stop-Limit / Trailing). Figma node 9260:26827:
 * container bg #171A1B, radius 10px, 4px padding, no gap; active pill bg #222628,
 * radius 8px, 8px padding, white text; inactive text #74797F. Legend/M = 12/16/-1%.
 */
export function SegmentedToggle<T extends string>({
  options,
  value,
  onChange,
  className,
  itemClassName,
}: {
  options: { value: T; label: React.ReactNode }[];
  value: T;
  onChange: (v: T) => void;
  /** Container overrides (gap, height). */
  className?: string;
  /** Per-item overrides (padding/text) for variants like the icon toggle. */
  itemClassName?: string;
}) {
  return (
    <div className={cn('bg-v2-btn-secondary flex items-center rounded-[10px] p-1', className)}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={cn(
            `flex-1 cursor-pointer select-none whitespace-nowrap rounded-[8px] px-2 py-2 text-[12px]
            font-normal leading-4 tracking-[-0.01em] outline-none transition-colors`,
            value === o.value
              ? 'bg-v2-surface-tertiary text-v2-text-primary'
              : 'text-v2-text-secondary hover:text-v2-text-primary',
            itemClassName,
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
